import { render } from "./Createchannel.vue?vue&type=template&id=c9e02482"
import script from "./Createchannel.vue?vue&type=script&lang=js"
export * from "./Createchannel.vue?vue&type=script&lang=js"

import "./Createchannel.vue?vue&type=style&index=0&id=c9e02482&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__